import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { QrCode } from "@phosphor-icons/react";

export default function AssetQrInline({ asset }) {
  if (!asset?.id) {
    return <div className="text-sm text-gray-500 py-8 text-center" data-testid="asset-qr-unsaved">Save the asset first to generate its docket QR code and PIN.</div>;
  }
  const url = `${window.location.origin}/docket?asset=${asset.id}`;
  return (
    <div className="text-center py-2" data-testid="asset-qr-inline">
      <p className="text-sm text-gray-500 mb-4">Print & attach to the machine. Workers scan it to submit a hire docket, then enter the PIN below.</p>
      <div className="flex justify-center">
        <QRCodeCanvas value={url} size={210} level="M" includeMargin data-testid="asset-qr-canvas-inline" />
      </div>
      <div className="mt-4 inline-block border border-gray-200 px-6 py-3">
        <div className="text-[11px] uppercase tracking-wider text-gray-400 inline-flex items-center gap-1"><QrCode size={13} /> Docket PIN</div>
        <div className="text-3xl font-extrabold tracking-[0.35em] text-equipr-black" data-testid="asset-qr-pin-inline">{asset.docket_pin || "----"}</div>
      </div>
      <p className="text-[11px] text-gray-400 mt-3 break-all">{url}</p>
    </div>
  );
}
